export const MARK_AS_PAID_STYLES = {
  WRAPPER:
    'flex flex-nowrap justify-between flex-col h-[532px] w-[568px] bg-bw00 rounded-lg border-[1px] border-bw03 px-[24px] pt-[20px] pb-[24px] box-border',
  TITLE: 'font-metricRMedium text-lg text-bw08 leading-6',
  SUBTITLE: 'font-metricR text-md text-bw07 leading-6',
  AMOUNT_TITLE: 'font-metricR text-md text-bw07 leading-6',
  AMOUNT_VALUE: 'font-metricRMedium text-md text-bw08 leading-6 ml-[5px] ',
  INPUT_STYLE:
    'cursor-pointer w-full h-[54px] rounded-lg border-[1px] pt-[5px] pr-[14px] pb-[8px] pl-[16px] relative fade',
  INPUT_TEXT_STYLE: 'font-metricR text-xxs text-bw06',
  ERROR_WRAPPER: 'my-[3px] flex items-center',
  ERROR_TEXT: 'ml-[4px] font-metricRMedium text-red02 text-sm',
  DATE_PICKER_WRAPPER:
    'absolute rounded-lg left-0 bottom-[-314px] w-fit shadow-chatBotButton bg-bw00 min-w-[260px] z-[100]',
  ICON: 'absolute top-[14px] right-[14px] fade',
};
